import { createTypedAsyncThunk, withOrgId } from "../utils/actions";
import * as API from "@/data/api/permissions";
import {
  RequestParams,
  TPermissionItem,
  TPermissionPayload,
} from "@/data/types";
import { State } from "../state/state";

export const getAllPermissionsAsync = createTypedAsyncThunk<
  { items: TPermissionItem[] },
  RequestParams,
  { state: State }
>("permissions/getAllPermissions", async (params, { getState }) => {
  return API.getAllPermissions(withOrgId(getState, params));
});

export const getPermissionByIdAsync = createTypedAsyncThunk<
  TPermissionItem,
  { permissionId: string; params?: RequestParams },
  { state: State }
>(
  "permissions/getPermissionById",
  async ({ permissionId, params = {} }, { getState }) => {
    return API.getPermissionById(permissionId, withOrgId(getState, params));
  }
);
